// @flow

import React, { Component } from "react";
import { Card, FormTextInput, Button, Icon, Grid, Alert, Dimmer } from "tabler-react";
import defaultStrings from "../../data/LoginPage.strings";
import { Auth } from '../../Auth/Auth';
import * as conf from "../../config/config";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { from } from "rxjs";
import { NavLink, withRouter } from "react-router-dom";
import Modal from 'react-modal';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      respuesta: "",
      username: "",
      password: "",
      showmessage: false,
      message: "No message",
      loginMessage: null
    };
    this.props.history.push('/login');
  }
  componentWillMount = () => {
    //alert(window.location);
  }
  changePassword = (event) => {
    this.setState({ password: event.target.value });
  }
  changeUsername = (event) => {
    this.setState({ username: event.target.value });
  }
  getLogin = async () => {
    let resp = [];
    let usuario;
    this.setState({ showmessage: false });
    await Auth("login", this.state.username, this.state.password).then((res) => {
      resp = res;
      if (res.lastUpdatePassword >= 60) { window.location.href = 'actualizar_password'; }
    }).catch(err => {
      if (err.response) {
        this.setState({ loginMessage: null });
        this.setState({ showmessage: true });
        this.setState({ username: '' });
        this.setState({ password: '' });
        this.setState({ message: err.response.data.message });
      } else {
        this.setState({ loginMessage: null });
        this.setState({ username: '' });
        this.setState({ password: '' });
        this.setState({ message: "" + err });
        this.setState({ showmessage: true });
      }
    });
    if (resp.token) {
      let navBarItems = [];
      this.setState({ loginMessage: "Cargando perfiles .." });
      let configuracionSubItems = [
        { value: "Roles", icon: "airplay", to: "/roles", LinkComponent: withRouter(NavLink) },
        { value: "Usuarios", icon: "user", to: "/usuarios", LinkComponent: withRouter(NavLink) },
        { value: "Proveedores", icon: "user", to: "/proveedores", LinkComponent: withRouter(NavLink) },
        { value: "Dispositivos", icon: "user", to: "/dispositivos", LinkComponent: withRouter(NavLink) },
      ];
      navBarItems.push({ value: "Configuración", icon: "settings", subItems: configuracionSubItems });
      
      navBarItems.push({ value: "Dispositivos", icon: "layers", to: "/dispositivos", LinkComponent: withRouter(NavLink), useExact: true });
      sessionStorage.setItem("navBarItems", JSON.stringify(navBarItems));
      window.location.href = "/";

    }
  }
  screenWidth = () => {
    //console.log("screen with: "+ window.screen.width)
    if (window.screen.width > 900) {
      return 4;
    } else {
      return 0;
    }
  }
  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.getLogin();
    }
  }
  render() {
    const {

      values,
      strings = {},

    } = this.props;
    return (
      <Grid.Col sm={12} lg={4} offset={this.screenWidth()} alignItems="center">
        <div className="p-4"></div>
        <Card>
          <Card.Body>
            <div className="col-12 text-center">
              <img src="images/skyangel.png" width="70" height="100" />
            </div>
            <div className="col-12 text-center" hidden={this.state.loginMessage}>
              {strings.title || defaultStrings.title}
            </div>
            <div hidden={!this.state.showmessage}>
              <Alert type="danger" icon="alert-triangle" //onDismissClick={ this.screenWidth }  isDismissible={true}
              >
                {this.state.message}
              </Alert>
            </div>

            <div hidden={!this.state.loginMessage} style={{ height: "40vh" }}>
              <h1 className="mt-4">{this.state.loginMessage}</h1>
              <Dimmer active={true} loader>
              </Dimmer>
            </div>
            <div hidden={this.state.loginMessage}>
              <FormTextInput
                name="username"
                label={defaultStrings.usernameLabel}
                placeholder={defaultStrings.usernamePlaceholder}
                onChange={this.changeUsername}
                //onBlur={onBlur}
                value={this.state.username}
              //error={errors && errors.email}
              />
              <FormTextInput
                name="password"
                type="password"
                label={strings.passwordLabel || defaultStrings.passwordLabel}
                placeholder={strings.passwordPlaceholder || defaultStrings.passwordPlaceholder}
                onKeyDown={this._handleKeyDown}
                onChange={this.changePassword}
                //onBlur={onBlur}
                value={this.state.password}
              //error={errors && errors.password}
              />
              <div className="col-12 text-right">
                <Button target="_blank" size="sm" RootComponent="a" color="primary" onClick={() => this.getLogin()} >
                  <span class="badge"><Icon link={true} name="user" />Login</span>
                </Button>
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <a href="/recuperar_password">Recuperar contraseña</a>
          </Card.Footer>
        </Card>
      </Grid.Col>
    );
  }
}

export default LoginPage;
